// extracted by mini-css-extract-plugin
export default {"actionItem":"passwordForm-module__actionItem__cX-5v","loader":"passwordForm-module__loader__JR+Dd"};